import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { useIntl } from 'react-intl'
import {
  Modal,
  MODAL_SIZE_LG,
  ModalHead,
  ModalBody,
  ModalFoot,
  SingleLoader,
  Flex,
  FlexItem,
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_LIGHT,
  SpacingVertical,
  SPACING_8,
  SPACING_32,
  ModalHeader
} from 'mailup-web-components'

import { useRecoilState, useRecoilValue } from 'recoil'

import {
  pageState,
  previewModalState
} from 'Pages/EmailMessagePreview/recoil/state/page'
import useMessageEditAction from 'Hooks/useMessageEditAction'
import styled from '@emotion/styled'

const PreviewModal = () => {
  const intl = useIntl()
  const { id } = useParams()
  const history = useHistory()

  const { isBee, messageType } = useRecoilValue(pageState)
  const [
    { previewImagePath, displayName, operativeSystem, browser, show },
    setModal
  ] = useRecoilState(previewModalState)
  const [imageLoading, setImageLoading] = useState(true)

  const handleClose = () => {
    setModal(prev => ({
      ...prev,
      show: false
    }))
  }

  const handleOverview = () => {
    history.push(`/messages/email/${id}/overview`)
  }

  const handleEdit = useMessageEditAction(id, isBee, messageType)

  return (
    <Modal
      show={show}
      onClose={handleClose}
      size={MODAL_SIZE_LG}
      closeOnOverlayClick
    >
      <SpacingVertical variant={SPACING_8} />
      <ModalHead>
        <Flex
          flexDirection='column'
          justifyContent='center'
          alignItems='center'
        >
          <Text variant={TEXT_VARIANT_BOLD}>{displayName}</Text>
          <Text variant={TEXT_VARIANT_LIGHT}>
            {operativeSystem} {browser}
          </Text>
        </Flex>
      </ModalHead>
      <SpacingVertical variant={SPACING_32} />
      {imageLoading && (
        <ModalBody>
          <Flex
            minHeight='200px'
            width='100%'
            justifyContent='center'
            alignItems='center'
          >
            <SingleLoader />
          </Flex>
        </ModalBody>
      )}
      <ModalBodyScrollable scrollable>
        <Container imageLoading={imageLoading}>
          <Flex minHeight='200px' width='100%' height='100%'>
            <img
              onLoad={() => setImageLoading(false)}
              src={previewImagePath}
              alt={displayName}
            />
          </Flex>
        </Container>
      </ModalBodyScrollable>
      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          data-mu-test='cta-edit-footer'
          onClick={handleOverview}
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Overview' })}
        </Button>

        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          data-mu-test='cta-edit-footer'
          onClick={handleEdit}
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Edit' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default PreviewModal

const ModalBodyScrollable = styled(ModalBody)`
  width: calc(100% + 15px);
  max-height: calc(100vh - 400px);
`

const Container = styled.div`
  ${({ imageLoading }) => !imageLoading && 'border: 2px solid #D5DADF;'}

  img {
    width: auto;
    max-width: 100%;
    margin: auto;
    ${({ imageLoading }) => `display: ${imageLoading ? 'none' : 'block'};`}
  }
`
